import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// Home & Inner Pages
import Homepage from "../HomePage";
import AboutPage from "../AboutPage/AboutPage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import ScrollToTop from "./ScrollToTop";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";

// Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Service Routes */}
          <Route path="/service" element={<SeviceSinglePage />} />
          <Route path="/services" element={<SeviceSinglePage />} />
          <Route path="/service-details" element={<SeviceSinglePage />} />
          <Route path="/service-details/:slug" element={<SeviceSinglePage />} />
          <Route path="/service-single/:slug" element={<SeviceSinglePage />} />
          <Route path="/service/:slug" element={<SeviceSinglePage />} />

          {/* Project / Portfolio Routes */}
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/projects" element={<ProjectPage />} />
          <Route path="/project-details" element={<ProjectDetails />} />
          <Route path="/project-details/:slug" element={<ProjectDetails />} />

          {/* Contact Route */}
          <Route path="/contact" element={<ContactPage />} />

          {/* Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
